<template>
  <div
    ref="combobox"
    class="w-full md:w-fit relative"
  >
    <label
      :for="name"
      :class="{'sr-only': hideLabel}"
      class="text-xs font-semibold"
    >{{ label }}</label>
    <div
      :id="name"
      role="radiogroup"
      class="flex flex-wrap gap-4 pt-2"
      :class="validation.$error && 'rounded-3xl bg-[#bf2231]/[.1]'"
    >
      <Checkbox
        v-for="option in props.options"
        :id="`${name}-combo-${option.value.replaceAll(' ', '-')}`" 
        :key="`${name}-combo-${option.value.replaceAll(' ', '-')}`" 
        class="mb-2"
        :value="selectedValue === option.value"
        :name="`${name}-combo-${option.value.replaceAll(' ', '-')}`" 
        :label="option.label" 
        type="radio"
        @update:value="onChecked(option.value)"
      />
    </div>
    <div
      v-if="validation.$error"
      class="text-red text-sm"
    >
      {{ validation.$errors[0].$message }}
    </div>
  </div>
</template>

<script setup>
import Checkbox from '@/Components/Input/Checkbox.vue';

const props = defineProps({
  label: {
    required: true,
    type: String,
  },
  hideLabel: {
    type: Boolean,
    default: false,
  },
  name: {
    required: true,
    type: String,
  },
  options: {
    type: Array,
    required: true,
  },
  validation: {
    type: [Function, Object],
    default: () => ({}),
  },
});

const selectedValue = defineModel({type: String});

const onChecked = (radioValue) => {
  selectedValue.value = radioValue;
};

</script>
